<div class="global-overlay-page">
  <div style="display: flex; justify-content: center;padding:20px;">
    <div style="width:100%;">

      <div class="menu">
        <input type="text" (keyup)="filter($event)" [value]="userFilter" placeholder="Filter users" />

        <div class="client-name">{{clientName}}</div>
      </div>

      <mat-table #table [dataSource]="loading ? [] : dataSource" matSort (matSortChange)="sortData()">

        <ng-container matColumnDef="client">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Client</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.client}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
          <mat-cell *matCellDef="let element"><span class="userEmail"
              (click)="userDetails(element.id)">{{element.email}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="hr">
          <mat-header-cell *matHeaderCellDef mat-sort-header>HR</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [checked]="element.hr" (change)="toggleHR($event, element.id)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="codes">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Codes</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.codes}}</mat-cell>
        </ng-container>



        <ng-container matColumnDef="super">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Super</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [checked]="element.super" (change)="toggleSuper($event, element.id)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ts">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.ts}}</mat-cell>
        </ng-container>




        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      @if (loading) {
      <div class="skeleton-container">
        @for (row of skeletonRows; track $index) {
        <div class="skeleton-row-flex">
          @for (weight of row; track $index) {
          <div class="skeleton-bar" [style.flex-grow]="weight"></div>
          }
        </div>
        }
      </div>
      }

      <div style="display: flex; justify-content: center;">
        <mat-paginator [length]="count" [pageSize]="10" (page)="onPaginateChange($event)" showFirstLastButtons
          hidePageSize="true"></mat-paginator>
      </div>


    </div>


  </div>
</div>